import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {IFilterFetchResult} from "../models/advanseFilter";
import {IFileData} from "../models/Book";
import {isHistoryBook, isInfoFileData} from "./typeChecker";

export  const LOGIN_URL = "https://api.vvsu.ru/services/api/sign_in";
export  const LOAD_FILE_URL = "https://api.vvsu.ru/services/api/load_book_file"

export const GET_BOOKS_URL = "https://api.vvsu.ru/services/api/get_library_documents";

export const GET_ADVANCE_FILTERS_URL = "https://api.vvsu.ru/services/api/get_advance_filters";
export const GET_ADVANCE_KEY_WORD_URL = "https://api.vvsu.ru/services/api/get_key_words";

/*
export const ADD_TO_FAVOURITE_URL = "https://api.vvsu.ru/services/api/add_to_favourite";
export const REMOVE_FROM_FAVOURITE_URL = "https://api.vvsu.ru/services/api/remove_to_favourite";
export const GET_USER_FAVOURITE_BOOKS_URL = "https://api.vvsu.ru/services/api/get_user_favourite_books";

export const ADD_TO_CART_URL = "https://api.vvsu.ru/services/api/add_to_cart";
export const REMOVE_FROM_CART_URL = "https://api.vvsu.ru/services/api/remove_from_cart";
export const GET_USER_CART_BOOKS_URL = "https://api.vvsu.ru/services/api/get_user_cart_books";
 */

export const ADD_TO_FAVOURITE_URL = "https://api.vvsu.ru/services/api/add_to_favourite";
export const REMOVE_FROM_FAVOURITE_URL = "https://api.vvsu.ru/services/api/remove_from_favourite";
export const GET_USER_FAVOURITE_BOOKS_URL = "https://api.vvsu.ru/services/api/get_user_favourite_books";

export const ADD_TO_CART_URL = "https://api.vvsu.ru/services/api/add_to_cart";
export const REMOVE_FROM_CART_URL = "https://api.vvsu.ru/services/api/remove_from_cart";
export const GET_USER_CART_BOOKS_URL = "https://api.vvsu.ru/services/api/get_user_cart_books";

export const GET_USER_HISTORY_BOOKS_URL = "https://api.vvsu.ru/services/api/get_user_history_books";

export const GET_BOOK_URL = "https://api.vvsu.ru/services/api/get_book";


export const generateUrlForFileView = (fileData:IFileData,token?:string | null) => {
  return `${LOAD_FILE_URL}?fileid=${fileData.fileId}${token ? `&token=${token}` : ''}${isInfoFileData(fileData) ? `&pln=${fileData.pln}` : ""}`
}